import { useQueryClient } from '@tanstack/react-query'
import { Link } from 'react-router'
import { trpc } from 'shared/api'
import { DoublePayments } from 'shared/components/double-payments'
import { Button } from 'shared/components/ui/button'
import { useTranslate } from 'shared/lib/i18n'
import { Handover } from './Handover'

/**
 * The handover section's shell (spec §15). Handover is the point operator's
 * counter act at their own Point (ADR-0029; an admin does not hand over — owner,
 * 2026-10-20). The server serves the shelf of the Point the operator is bound to;
 * an operator has one Point, so the screen does not name it. `Handover` is the
 * component the tests drive against a stubbed tRPC client.
 */
export function HandoverPage() {
	const { t } = useTranslate()
	const queryClient = useQueryClient()
	// A handover is done in the operator's open Shift (ADR-0035): the way to it.
	const shiftLink = (
		<Button asChild variant='outline' size='sm' data-testid='handover-to-shift'>
			<Link to='/money'>{t('handover.toShift')}</Link>
		</Button>
	)
	// The Point's open double payments (ADR-0046), resolved here in two steps, in order.
	return (
		<Handover
			shiftLink={shiftLink}
			footer={<DoublePayments />}
			onCashCancelled={() =>
				void queryClient.invalidateQueries({ queryKey: trpc.payments.DoublePayments.queryKey() })
			}
		/>
	)
}
